import React, { memo } from "react";

import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Tooltip from "@mui/material/Tooltip";
import { Facebook, Instagram } from "@mui/icons-material";

function Footer() {
  return (
    <div className="footer">
      <div className="footer-block first">
        <span className="footer-block-item">
          Nanaimo Ladysmith Schools Foundation Charity Number 11905 2801 RR0001
        </span>
        <span className="footer-block-item">
          Contact the foundation by email{" "}
          <a href="mailto:awards@nlsf.ca">awards@nlsf.ca</a> or phone
          <a href="tel:+12507534074">1-250-753-4074</a>
        </span>
      </div>
      <div className="footer-block second">
        <span>Reach out to us through social media</span>
        <div className="links">
          <Tooltip title="Facebook">
            <Link
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener"
              aria-label="Facebook"
            >
              <IconButton color="primary">
                <Facebook />
              </IconButton>
            </Link>
          </Tooltip>
          <Tooltip title="Instagram">
            <Link
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener"
              aria-label="Instagram"
            >
              <IconButton color="secondary">
                <Instagram />
              </IconButton>
            </Link>
          </Tooltip>
        </div>
        <span>© 2024 Nanaimo Ladysmith Public Schools</span>
      </div>
    </div>
  );
}

export default memo(Footer);
